export default __webpack_public_path__ + "static/media/toothbrush.d1c109e7.svg";